import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createSuccessToast } from '@adflow/frontend/ui-toasts';
import { apiRequest, handleRequestErrors } from '@adflow/frontend/util-query';
import { SyncFacebookAccounts } from '@adflow/shared/data-facebook-ads';
import { SyncGoogleAdsAccounts } from '@adflow/shared/data-google-ads';
import { SyncGMBAccounts } from '@adflow/shared/data-google-my-business';
import { SyncSalesforceAccounts } from '@adflow/shared/data-salesforce-import';

export function useSyncGoogleAdsAccountsMutation() {
	const { t } = useTranslation('common');
	return useMutation({
		mutationFn: () => apiRequest(SyncGoogleAdsAccounts, {}),
		onSuccess: () => {
			createSuccessToast(t('sync.googleAdsAccountsSyncedSuccessfully'));
		},
		onError: (err) => {
			handleRequestErrors([err], {
				errorMessage: t('sync.failedToSyncGoogleAdsAccounts'),
			});
		},
	});
}

export function useSyncFacebookAccountsMutation() {
	const { t } = useTranslation('common');
	return useMutation({
		mutationFn: () => apiRequest(SyncFacebookAccounts, {}),
		onSuccess: () => {
			createSuccessToast(t('sync.facebookAccountsSyncedSuccessfully'));
		},
		onError: (err) => {
			handleRequestErrors([err], {
				errorMessage: t('sync.failedToSyncFacebookAccounts'),
			});
		},
	});
}

export function useSyncSalesforceAccountsMutation() {
	const { t } = useTranslation('common');
	return useMutation({
		mutationFn: () => apiRequest(SyncSalesforceAccounts, {}),
		onSuccess: () => {
			createSuccessToast(t('sync.salesforceAccountsSyncedSuccessfully'));
		},
		onError: (err) => {
			handleRequestErrors([err], {
				errorMessage: t('sync.failedToSyncSalesforceAccounts'),
			});
		},
	});
}

export function useSyncGMBAccountsMutation() {
	const { t } = useTranslation('common');
	return useMutation({
		mutationFn: () => apiRequest(SyncGMBAccounts, {}),
		onSuccess: () => {
			createSuccessToast(t('sync.gmbAccountsSyncedSuccessfully'));
		},
		onError: (err) => {
			handleRequestErrors([err], {
				errorMessage: t('sync.failedToSyncGmbAccounts'),
			});
		},
	});
}
